var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllusComprarAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#88e7fd;opacity:0.15;}.cls-10,.cls-11,.cls-15,.cls-16,.cls-18,.cls-3,.cls-4,.cls-6,.cls-7,.cls-9{isolation:isolate;}.cls-4,.cls-5{fill:#663ea8;}.cls-10,.cls-11,.cls-4{opacity:0.1;}.cls-6,.cls-9{opacity:0.2;}.cls-7{opacity:0.4;}.cls-8{fill:#636780;}.cls-10,.cls-14,.cls-18,.cls-9{fill:#fff;}.cls-12{fill:#dce0ed;}.cls-13{fill:#f0f0f4;}.cls-15{opacity:0.05;}.cls-16{opacity:0.03;}.cls-17{fill:#4b4b5b;}.cls-18{opacity:0.3;}.cls-19{clip-path:url(#clip-path-2);}.cls-20{fill:#c5cbef;}.cls-21{fill:#dcf1f7;}.cls-22{fill:#585afa;}.cls-23{fill:#3836bd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34,
    y: 5,
    width: 134,
    height: 130
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -189.8,
    y: -0.2,
    width: 167.8,
    height: 136.2
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_city_driver_jh2h",
    "data-name": "undraw city driver jh2h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1268",
    "data-name": "Trazado 1268",
    className: "cls-3",
    d: "M48.72,89c4.31,7.35,13.08,12.26,22.16,15.5a100.42,100.42,0,0,0,39,5.35c2.33-.12,4.65-.33,7-.61a102.39,102.39,0,0,0,23.28-5.59c2.13-.8,4.23-1.66,6.29-2.6a81.48,81.48,0,0,0,9.82-5.3c.79-.49,1.56-1,2.32-1.51l1.58-1.09a21.09,21.09,0,0,1,3.56-2c.39-.16.79-.3,1.2-.43,4.07-1.28,8.77-.8,13,.2,3.23.75,6.37,1.79,9.59,2.53a38.61,38.61,0,0,0,4.38.77,28.23,28.23,0,0,0,9.82-.71l.28-.07q.68-.18,1.35-.39l.27-.08c.43-.14.86-.29,1.27-.45l.27-.1c.44-.16.86-.34,1.27-.52l.45-.2a26.46,26.46,0,0,0,6.36-4.09l.16-.13.76-.7.27-.27q.44-.43.84-.9a1.42,1.42,0,0,0,.12-.13,18.4,18.4,0,0,0,2.74-4.09.83.83,0,0,0,.07-.13c.21-.46.41-.93.59-1.4.07-.2.14-.4.2-.6L219,79a30.34,30.34,0,0,0,1-9V69a84.22,84.22,0,0,0-1-14.62s0-.07,0-.1a39.58,39.58,0,0,0-1.19-4.8,31.63,31.63,0,0,0-2-4.86A45,45,0,0,0,207.64,34c-8.14-8.24-18.83-15.17-31.34-17.76-13.47-2.79-28.45-.11-39.32,7-3.32,2.18-6.3,4.76-10,6.42a14.76,14.76,0,0,1-10.53.92,19.4,19.4,0,0,0-8-1.27A79.16,79.16,0,0,0,88.9,32.66l-.76.23C71.77,38.06,57.7,48.31,50.4,61.49c-.2.35-.39.7-.57,1.06C45.48,70.94,43.91,80.78,48.72,89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_668",
    "data-name": "Rect\\xE1ngulo 668",
    className: "cls-4",
    x: 109.86,
    y: 75.41,
    width: 6.96,
    height: 6.96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_669",
    "data-name": "Rect\\xE1ngulo 669",
    className: "cls-4",
    x: 109.86,
    y: 89.84,
    width: 6.96,
    height: 6.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1271",
    "data-name": "Trazado 1271",
    className: "cls-4",
    d: "M109.86,104.27v5.5q3.49-.22,7-.74v-4.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_670",
    "data-name": "Rect\\xE1ngulo 670",
    className: "cls-4",
    x: 138.2,
    y: 70.37,
    width: 24.37,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_671",
    "data-name": "Rect\\xE1ngulo 671",
    className: "cls-4",
    x: 138.2,
    y: 79.94,
    width: 24.37,
    height: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1272",
    "data-name": "Trazado 1272",
    className: "cls-4",
    d: "M138.2,89.52v3.15h18c.78-.6,1.55-1.21,2.32-1.84l1.58-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1273",
    "data-name": "Trazado 1273",
    className: "cls-4",
    d: "M138.2,99.11v3.15h1.9q3.19-1.45,6.29-3.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_682",
    "data-name": "Rect\\xE1ngulo 682",
    className: "cls-4",
    x: 93.7,
    y: 73.32,
    width: 4.53,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_684",
    "data-name": "Rect\\xE1ngulo 684",
    className: "cls-4",
    x: 93.7,
    y: 84.51,
    width: 4.53,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_685",
    "data-name": "Rect\\xE1ngulo 685",
    className: "cls-4",
    x: 76.4,
    y: 84.51,
    width: 4.53,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_686",
    "data-name": "Rect\\xE1ngulo 686",
    className: "cls-4",
    x: 93.7,
    y: 95.68,
    width: 4.53,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_687",
    "data-name": "Rect\\xE1ngulo 687",
    className: "cls-4",
    x: 76.4,
    y: 95.68,
    width: 4.53,
    height: 4.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1274",
    "data-name": "Trazado 1274",
    className: "cls-4",
    d: "M98.23,109.79v-2.93H93.7v2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1289",
    "data-name": "Trazado 1289",
    className: "cls-5",
    d: "M74.09,104.12l-1.63,1.73-2.6-4.57.24-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1290",
    "data-name": "Trazado 1290",
    className: "cls-6",
    d: "M74.09,104.12l-1.63,1.73-2.6-4.57.24-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1294",
    "data-name": "Trazado 1294",
    className: "cls-5",
    d: "M194.08,56.77s7.49,8.4,9.87,15.39L139.28,79.3l-34.64-7.13s13.72-16.44,17.43-17.08S194.08,56.77,194.08,56.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1295",
    "data-name": "Trazado 1295",
    className: "cls-7",
    d: "M194.08,56.77s7.49,8.4,9.87,15.39L139.28,79.3l-34.64-7.13s13.72-16.44,17.43-17.08S194.08,56.77,194.08,56.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1296",
    "data-name": "Trazado 1296",
    className: "cls-5",
    d: "M146.63,78.13l-10.37,29.12V99.88l-2.89-8.25-8-3.54-10.15,4.6-3.63,1.13-.32-6.72,12.07-5.94,5.61-2.7,12.86-1.12,3.55-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1297",
    "data-name": "Trazado 1297",
    className: "cls-5",
    d: "M142,81.16l-9.44,1.08c.43-3.77-2.37-3.77-2.37-3.77l9.44-1.63H144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1298",
    "data-name": "Trazado 1298",
    className: "cls-8",
    d: "M136.25,111.73h-6.69l-19.39-.65s-.42,3.7-5.52,2.82c0,0-2.81.18-3.11-1.34s6.4-15.64,6.4-15.64l9.14-6.83,8.28-2,6,1.75,3.78,6,2.38,8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1299",
    "data-name": "Trazado 1299",
    className: "cls-6",
    d: "M136.25,111.73h-6.69l-19.39-.65s-.42,3.7-5.52,2.82c0,0-2.81.18-3.11-1.34s6.4-15.64,6.4-15.64l9.14-6.83,8.28-2,6,1.75,3.78,6,2.38,8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1302",
    "data-name": "Trazado 1302",
    className: "cls-5",
    d: "M170.68,58.26l-17.12-.16a2.92,2.92,0,0,0-2.75,2.07L145.47,72.3A2.07,2.07,0,0,0,146.68,75a2.11,2.11,0,0,0,.74.14l25-1.65a3.55,3.55,0,0,0,3.15-3.91,4.37,4.37,0,0,0-.09-.5l-1.81-8.23A3.16,3.16,0,0,0,170.68,58.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1303",
    "data-name": "Trazado 1303",
    className: "cls-9",
    d: "M170.68,58.26l-17.12-.16a2.92,2.92,0,0,0-2.75,2.07L145.47,72.3A2.07,2.07,0,0,0,146.68,75a2.11,2.11,0,0,0,.74.14l25-1.65a3.55,3.55,0,0,0,3.15-3.91,4.37,4.37,0,0,0-.09-.5l-1.81-8.23A3.16,3.16,0,0,0,170.68,58.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1304",
    "data-name": "Trazado 1304",
    className: "cls-5",
    d: "M144.07,58.07c-4.68-.08-17.09-.44-23.26-1.86,0,0-10.59,8-13.76,14,0,0,16.5,4,27.91,4.56A4.32,4.32,0,0,0,139,72.34l6.07-12.57a1.19,1.19,0,0,0-.54-1.58,1.26,1.26,0,0,0-.5-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1305",
    "data-name": "Trazado 1305",
    className: "cls-9",
    d: "M144.07,58.07c-4.68-.08-17.09-.44-23.26-1.86,0,0-10.59,8-13.76,14,0,0,16.5,4,27.91,4.56A4.32,4.32,0,0,0,139,72.34l6.07-12.57a1.19,1.19,0,0,0-.54-1.58,1.26,1.26,0,0,0-.5-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1306",
    "data-name": "Trazado 1306",
    className: "cls-10",
    d: "M138.13,59.89c-1.95,0-5.75-.14-9.47-.41A17.81,17.81,0,0,0,114,65.4l-.12.14a2.31,2.31,0,0,0,1.27,3.78,114.33,114.33,0,0,0,16.46,2.48,3.09,3.09,0,0,0,2.94-1.74l4.32-9a.84.84,0,0,0-.39-1.13.85.85,0,0,0-.35-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1307",
    "data-name": "Trazado 1307",
    className: "cls-5",
    d: "M136.25,107.25v4.48l49.5-7.56a6.27,6.27,0,0,1,3.87-.32c1.79-.88,3.09-4.28,3.13-4.39h0l-.94-2.71L199.4,84.2l10.1.42c-1.59-12.69-6.16-13.3-6.16-13.3L144,76.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1308",
    "data-name": "Trazado 1308",
    className: "cls-11",
    d: "M146.92,80.52a3,3,0,0,0,2.41.78c2,0,2.39-1.76,2.44-2.79a6.26,6.26,0,0,0,0-.75l-2.63-.8-.54.5L147,79A1.12,1.12,0,0,0,146.92,80.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1309",
    "data-name": "Trazado 1309",
    className: "cls-12",
    d: "M146.92,80.38a3,3,0,0,0,2.41.78c2,0,2.39-1.76,2.44-2.79a6.26,6.26,0,0,0,0-.75l-2.63-.8-.54.5L147,78.81A1.12,1.12,0,0,0,146.92,80.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1310",
    "data-name": "Trazado 1310",
    className: "cls-11",
    d: "M148.58,77.32a2,2,0,0,0,1.33,1.09l1.85,0a3.76,3.76,0,0,0,0-.75l-2.63-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1311",
    "data-name": "Trazado 1311",
    className: "cls-13",
    d: "M155.28,70.77s4.2.56,3.08,4.35c-.85,2.88-2.74,3.07-3.61,3-.51,0-1-.06-1.52-.05l-3.32.07a1.81,1.81,0,0,1-1.4-2.14,1.05,1.05,0,0,1,.05-.19C149.08,73.91,151.5,70.45,155.28,70.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1316",
    "data-name": "Trazado 1316",
    className: "cls-1",
    d: "M136.25,107.25v4.48l49.5-7.56a6.27,6.27,0,0,1,3.87-.32c1.79-.88,3.09-4.28,3.13-4.39h0l-3.29-.07-9.52,1.33-34.59,5a64.69,64.69,0,0,0-6.49,1A12.19,12.19,0,0,1,136.25,107.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1317",
    "data-name": "Trazado 1317",
    className: "cls-11",
    d: "M136.25,107.11v4.48l49.5-7.56a6.27,6.27,0,0,1,3.87-.32c1.79-.88,3.09-4.28,3.13-4.39h0l-3.29-.07-9.52,1.33-34.59,5a64.07,64.07,0,0,0-6.48,1A12.42,12.42,0,0,1,136.25,107.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1318",
    "data-name": "Trazado 1318",
    className: "cls-5",
    d: "M136.25,107.25v4.48l49.5-7.56a6.27,6.27,0,0,1,3.87-.32c1.79-.88,3.09-4.28,3.13-4.39h0l-3.29-.07-9.52,1.33-34.59,5a64.69,64.69,0,0,0-6.49,1A12.19,12.19,0,0,1,136.25,107.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1319",
    "data-name": "Trazado 1319",
    className: "cls-6",
    d: "M136.25,107.25v4.48l49.5-7.56a6.27,6.27,0,0,1,3.87-.32c1.79-.88,3.09-4.28,3.13-4.39h0l-3.29-.07-9.52,1.33-34.59,5a64.69,64.69,0,0,0-6.49,1A12.19,12.19,0,0,1,136.25,107.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1320",
    "data-name": "Trazado 1320",
    className: "cls-1",
    d: "M69.44,90.78a82.59,82.59,0,0,0,36.89,7.56s4.58.22,4.9-.2-1.18,1.77-1.18,1.77a1.92,1.92,0,0,0-1.13-.59c-.56,0-3.12.19-3.12.19S76.52,98.27,69,91.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1322",
    "data-name": "Trazado 1322",
    className: "cls-5",
    d: "M69,96.4c-.12.46-.41,1.73,0,2.07a1.81,1.81,0,0,1,.44.83,13.49,13.49,0,0,1,.4,2l4.76,5.32,8.05,3.15,19.24,1.33,11.62-18.89,26.1-15.36-7.13-.39c-7.13-.4-27.36-4.87-27.36-4.87l-22.89,5a15.35,15.35,0,0,0-9.18,6A31.19,31.19,0,0,0,69,90.78a3,3,0,0,0-.5,1.83,14.16,14.16,0,0,0,.4,3.24c.06.25.1.39.1.39A1.45,1.45,0,0,1,69,96.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1323",
    "data-name": "Trazado 1323",
    className: "cls-11",
    d: "M138.87,106.39s1.4-15-9.1-19c0,0-14.77-6.23-23.45,10.71l-4.41,9.65A5.06,5.06,0,0,1,97.22,110s-16.16-.48-24.7-5.94L69.86,101s1.33,4.34,2.66,5.32c0,0,5.25,6.15,24.36,7.28,0,0,7.81.83,10.17-6.58,0,0,3.2-16.8,19.43-16.66,0,0,9.54.19,9.77,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1324",
    "data-name": "Trazado 1324",
    className: "cls-5",
    d: "M138.87,106.67s1.4-15-9.1-19c0,0-14.77-6.23-23.45,10.7L101.91,108a5.08,5.08,0,0,1-4.68,2.31s-16.17-.49-24.7-6l-2.67-3.07s1.33,4.33,2.66,5.31c0,0,5.24,6.16,24.35,7.28,0,0,7.81.84,10.17-6.58,0,0,3.2-16.8,19.43-16.65,0,0,9.54.19,9.77,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1325",
    "data-name": "Trazado 1325",
    className: "cls-6",
    d: "M138.87,106.67s1.4-15-9.1-19c0,0-14.77-6.23-23.45,10.7L101.91,108a5.08,5.08,0,0,1-4.68,2.31s-16.17-.49-24.7-6l-2.67-3.07s1.33,4.33,2.66,5.31c0,0,5.24,6.16,24.35,7.28,0,0,7.81.84,10.17-6.58,0,0,3.2-16.8,19.43-16.65,0,0,9.54.19,9.77,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1326",
    "data-name": "Trazado 1326",
    className: "cls-6",
    d: "M141.29,106.21l.63-20.82a22.16,22.16,0,0,1,.16-4.23,17.4,17.4,0,0,1,1.2-3.45,2.47,2.47,0,0,1,.81-.83l.37-.1-.41,0c-.29.06-.56.36-.82.78A8,8,0,0,0,142,81.14a21.5,21.5,0,0,0-.16,4.24l-.63,20.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1327",
    "data-name": "Trazado 1327",
    className: "cls-6",
    d: "M128.44,90.77l.13,0a8.82,8.82,0,0,1,1.25-3.12c2-2.87,2.67-4.82,2.74-6.13a2.88,2.88,0,0,0-2.45-3.18h0l-.25,0a3.61,3.61,0,0,1,2.42,1.85,3.31,3.31,0,0,1,.16,1.32c-.08,1.28-.74,3.19-2.72,6A8.61,8.61,0,0,0,128.44,90.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1328",
    "data-name": "Trazado 1328",
    className: "cls-6",
    d: "M83.62,84c8.91-5.32,27.79-10.27,28-10.32l0-.13c-.19,0-19.08,5-28,10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1329",
    "data-name": "Trazado 1329",
    className: "cls-6",
    d: "M70.65,91.36C74,85.43,83.08,80.56,90.1,77.5a127,127,0,0,1,14.56-5.27l0-.13A123.82,123.82,0,0,0,90,77.37c-7,3.06-16.12,8-19.51,13.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_104",
    "data-name": "Elipse 104",
    className: "cls-11",
    cx: 74.56,
    cy: 84.19,
    rx: 6.85,
    ry: 1.61,
    transform: "translate(-37.55 93.08) rotate(-53)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_105",
    "data-name": "Elipse 105",
    className: "cls-12",
    cx: 74.56,
    cy: 83.91,
    rx: 6.85,
    ry: 1.61,
    transform: "translate(-37.33 92.97) rotate(-53)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_106",
    "data-name": "Elipse 106",
    className: "cls-11",
    cx: 74.37,
    cy: 83.93,
    rx: 5.66,
    ry: 1.05,
    transform: "translate(-37.41 92.82) rotate(-53)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_107",
    "data-name": "Elipse 107",
    className: "cls-13",
    cx: 74.37,
    cy: 83.79,
    rx: 5.66,
    ry: 1.05,
    transform: "translate(-37.3 92.77) rotate(-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1330",
    "data-name": "Trazado 1330",
    className: "cls-11",
    d: "M91.38,94.67s-.45-3.43-3.15-4.2c0,0-9.16-2.66-11.16-2.7a3.49,3.49,0,0,0-3.43.91l-1.4,1.89s-1,1.54,1.19,1.82c0,0,11.08,4.06,15.89,4.49a5.66,5.66,0,0,1,.81.12C90.83,97.14,92.3,97.19,91.38,94.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1331",
    "data-name": "Trazado 1331",
    className: "cls-13",
    d: "M91.24,94.52s-.45-3.43-3.15-4.2c0,0-9.16-2.65-11.16-2.69a3.47,3.47,0,0,0-3.43.91l-1.4,1.89s-1,1.54,1.2,1.82c0,0,11.07,4.06,15.88,4.48a7.58,7.58,0,0,1,.81.13C90.69,97,92.17,97.05,91.24,94.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1332",
    "data-name": "Trazado 1332",
    className: "cls-11",
    d: "M90.28,94.23s-.43-2.93-2.93-3.59c0,0-8.52-2.27-10.37-2.3a3.41,3.41,0,0,0-3.19.78l-1.3,1.61s-.91,1.32,1.1,1.56c0,0,10.3,3.48,14.77,3.84a6.42,6.42,0,0,1,.75.1C89.76,96.34,91.13,96.39,90.28,94.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1333",
    "data-name": "Trazado 1333",
    className: "cls-8",
    d: "M90.14,94.09s-.43-2.93-2.93-3.59c0,0-8.52-2.28-10.38-2.3a3.42,3.42,0,0,0-3.18.77l-1.3,1.63s-.91,1.31,1.1,1.55c0,0,10.3,3.48,14.77,3.84a6.46,6.46,0,0,1,.75.11C89.62,96.21,91,96.25,90.14,94.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1334",
    "data-name": "Trazado 1334",
    className: "cls-13",
    d: "M89.42,92.28v-.14c-.12,0-12.57-1.56-15.25-3.63l-.08.11C76.8,90.71,88.9,92.21,89.42,92.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1335",
    "data-name": "Trazado 1335",
    className: "cls-13",
    d: "M90.07,93.89l0-.13c-.14,0-13.84-2.56-16.79-4.39l-.07.12C76.21,91.33,89.93,93.87,90.07,93.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1336",
    "data-name": "Trazado 1336",
    className: "cls-13",
    d: "M90.4,95.22l0-.13c-.16,0-15.92-3-17.87-4.75l-.09.1C74.43,92.21,89.74,95.1,90.4,95.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1337",
    "data-name": "Trazado 1337",
    className: "cls-11",
    d: "M74,95.29a65.58,65.58,0,0,0,12.19,3.59c.55.1,1.1.23,1.64.37a5,5,0,0,0,2,.24c.8-.21,1.25.77.38,1.54l0,0a3.08,3.08,0,0,1-2.32.76l-1.33-.11S75.67,99.35,72.64,97.5c0,0-1.38-1-1.48-2s-.24-1.91.86-1.28S74,95.29,74,95.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1338",
    "data-name": "Trazado 1338",
    className: "cls-13",
    d: "M73.86,95.16a66.32,66.32,0,0,0,12.19,3.58c.55.1,1.1.23,1.64.37a5,5,0,0,0,2,.24c.81-.21,1.25.77.38,1.54l0,0a3.26,3.26,0,0,1-2.39.79l-1.28-.11h0c-.37-.08-10.88-2.41-13.86-4.22h0c-.09-.07-1.38-1-1.48-2s-.23-1.91.87-1.28,1.88,1,2,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1339",
    "data-name": "Trazado 1339",
    className: "cls-11",
    d: "M74.65,95.94a68.55,68.55,0,0,0,10.11,3.18c.52.11,1,.25,1.55.4a5.43,5.43,0,0,0,1.65.27c.7-.09,1,.6.24,1.07h0a3,3,0,0,1-2,.4L85,101.11s-9.13-2.3-11.62-3.75c0,0-1.13-.73-1.16-1.46s-.1-1.3.8-.81S74.65,95.94,74.65,95.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1340",
    "data-name": "Trazado 1340",
    className: "cls-8",
    d: "M74.51,95.8A68.8,68.8,0,0,0,84.61,99c.52.11,1,.25,1.55.4a5.43,5.43,0,0,0,1.65.27c.7-.09,1,.6.25,1.07h0a3.1,3.1,0,0,1-2,.4L84.87,101h0c-.18,0-9.14-2.31-11.61-3.74h0s-1.13-.74-1.16-1.46-.1-1.31.8-.81,1.58.84,1.62.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_108",
    "data-name": "Elipse 108",
    className: "cls-11",
    cx: 95.75,
    cy: 101.74,
    rx: 1.36,
    ry: 1.84,
    transform: "translate(-4.96 4.91) rotate(-2.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_109",
    "data-name": "Elipse 109",
    className: "cls-13",
    cx: 95.79,
    cy: 101.73,
    rx: 1.36,
    ry: 1.84,
    transform: "translate(-4.97 4.92) rotate(-2.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1341",
    "data-name": "Trazado 1341",
    className: "cls-11",
    d: "M87.76,103.13s7.12,1.09,9,1.19S99,105.48,99,105.48s.45,2.66-2.17,1.89l-9.31-1.05s-1.26,0-1.26-1.68v-.39a3.48,3.48,0,0,0-.07-.64C86.09,103.34,86.23,102.9,87.76,103.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1342",
    "data-name": "Trazado 1342",
    className: "cls-13",
    d: "M87.62,103s7.12,1.09,9,1.19,2.17,1.16,2.17,1.16.46,2.66-2.17,1.89l-9.31-1s-1.26,0-1.26-1.68v-.39a3.47,3.47,0,0,0-.06-.64C86,103.21,86.09,102.77,87.62,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1343",
    "data-name": "Trazado 1343",
    className: "cls-13",
    d: "M69,98.48a1.78,1.78,0,0,1,.45.83h0l2.3,1.63a.19.19,0,0,0,.27,0,.2.2,0,0,0,0-.11V99.07a1.42,1.42,0,0,0-.69-1.22L69,96.4C68.85,96.87,68.56,98.13,69,98.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1344",
    "data-name": "Trazado 1344",
    className: "cls-8",
    d: "M85.35,103.22l.11,1.73a1.16,1.16,0,0,1-1.07,1.25,1.07,1.07,0,0,1-.25,0,31.64,31.64,0,0,1-11.13-4l-.3-3.54a.5.5,0,0,1,.45-.55.51.51,0,0,1,.24,0c1.95.87,7.18,3.1,10.5,3.52A1.68,1.68,0,0,1,85.35,103.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1345",
    "data-name": "Trazado 1345",
    className: "cls-5",
    d: "M84.28,102.33v2.82s-8.68-2.05-10.6-3.43V99A43.74,43.74,0,0,0,84.28,102.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1346",
    "data-name": "Trazado 1346",
    className: "cls-5",
    d: "M69.06,96c.44,0,.8-.79.8-1.71s-.37-1.71-.81-1.71a.51.51,0,0,0-.38.18A14.72,14.72,0,0,0,69.06,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1347",
    "data-name": "Trazado 1347",
    className: "cls-13",
    d: "M68.93,95.85c.44,0,.79-.79.79-1.71s-.36-1.72-.81-1.72a.56.56,0,0,0-.38.19A14.16,14.16,0,0,0,68.93,95.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1348",
    "data-name": "Trazado 1348",
    className: "cls-8",
    d: "M108.84,107.8c0,15.38,6.5,15.71,15,15.71,6.77,0,9.54-7,9.54-15.71s-2.17-15.69-8.94-15.69S108.84,99.13,108.84,107.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1349",
    "data-name": "Trazado 1349",
    className: "cls-6",
    d: "M108.84,107.8c0,15.38,6.5,15.71,15,15.71,6.77,0,9.54-7,9.54-15.71s-2.17-15.69-8.94-15.69S108.84,99.13,108.84,107.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_110",
    "data-name": "Elipse 110",
    className: "cls-8",
    cx: 124.82,
    cy: 107.8,
    rx: 8.54,
    ry: 15.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1353",
    "data-name": "Trazado 1353",
    className: "cls-13",
    d: "M123.33,108.46c0,5.65,1.2,10.17,3.7,10.17s5.47-4.58,5.47-10.23-1-10.62-3.54-10.62S123.33,102.81,123.33,108.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1354",
    "data-name": "Trazado 1354",
    className: "cls-8",
    d: "M123.33,108.25q0,.65,0,1.26a20.34,20.34,0,0,0,.35,3.21c.4,2.08,1.13,3.52,2.23,3.8a1.58,1.58,0,0,0,.38,0,2.47,2.47,0,0,0,1.6-.7,8.92,8.92,0,0,0,2.47-4.64,13.3,13.3,0,0,0,.33-2.35c0-.22,0-.44,0-.67a28,28,0,0,0-.33-4.57,11.06,11.06,0,0,0-.74-2.6c-.45-.94-1-1.51-1.78-1.51a2.49,2.49,0,0,0-1.57.72,7.64,7.64,0,0,0-1.72,2.42A13,13,0,0,0,123.33,108.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1355",
    "data-name": "Trazado 1355",
    className: "cls-13",
    d: "M123.36,109.5a20.21,20.21,0,0,0,.35,3.21c.05-.08,1.46-2.3,2.53-.87.78,1,.12,3.42-.3,4.67a1.58,1.58,0,0,0,.38,0,2.53,2.53,0,0,0,1.6-.71v-.16s-.63-2.66,1-4.3a1.91,1.91,0,0,1,1.42-.17,13.54,13.54,0,0,0,.33-2.36,3.93,3.93,0,0,1-.72-3.45c.15-.81.29-1.39.4-1.79a10.29,10.29,0,0,0-.74-2.6s-.33,2.38-1.56,2.52-1.77-3.21-1.79-3.3a7.64,7.64,0,0,0-1.72,2.41s2,1.12,1.4,4.08A3.16,3.16,0,0,1,123.36,109.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    className: "cls-8",
    cx: 127.96,
    cy: 108.01,
    rx: 2.17,
    ry: 0.93,
    transform: "translate(9.87 226.74) rotate(-85.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1357",
    "data-name": "Trazado 1357",
    className: "cls-6",
    d: "M104.37,83.86l.06.13s4.89-2.12,22.83-5.16l2.6-.43.25,0c2.87-.47,6-1,9.54-1.46l0-.15c-4.74.69-8.87,1.34-12.48,2C109.25,81.75,104.43,83.83,104.37,83.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1358",
    "data-name": "Trazado 1358",
    className: "cls-11",
    d: "M195.32,57.27s-1.63-2.76-7.19-3c0,0-40.63-5.31-66.29.21,0,0-2.19,1,.19,1.55S179,58.57,195.32,57.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1359",
    "data-name": "Trazado 1359",
    className: "cls-14",
    d: "M195.32,57s-1.63-2.76-7.19-3c0,0-40.63-5.3-66.29.21,0,0-2.19,1,.19,1.55S179,58.29,195.32,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1361",
    "data-name": "Trazado 1361",
    className: "cls-11",
    d: "M175.19,69.26,173.38,61a3.14,3.14,0,0,0-3-2.55l-17.12-.17a2.84,2.84,0,0,0-1.79.64,2.82,2.82,0,0,1,2.06-.9l17.12.17a3.14,3.14,0,0,1,3,2.56L175.47,69a3.74,3.74,0,0,1-1.2,3.67A3.77,3.77,0,0,0,175.19,69.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1362",
    "data-name": "Trazado 1362",
    className: "cls-11",
    d: "M138.17,72.72l6.06-12.56a1.17,1.17,0,0,0-.55-1.57,1,1,0,0,0-.49-.12c-4.62-.08-16.75-.43-23-1.8l.62-.48c6.17,1.42,18.58,1.78,23.26,1.86a1.18,1.18,0,0,1,1.15,1.21,1.16,1.16,0,0,1-.11.48L139.05,72.3a4.35,4.35,0,0,1-2.48,2.21A4.26,4.26,0,0,0,138.17,72.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_690",
    "data-name": "Rect\\xE1ngulo 690",
    className: "cls-5",
    x: 136.25,
    y: 106.66,
    width: 2.61,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_691",
    "data-name": "Rect\\xE1ngulo 691",
    className: "cls-6",
    x: 136.25,
    y: 106.66,
    width: 2.61,
    height: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1366",
    "data-name": "Trazado 1366",
    className: "cls-11",
    d: "M126.48,118c2.54,0,5.56-4.59,5.56-10.26,0-3.88-.49-7.44-1.63-9.3,1.46,1.58,2.09,5.55,2.09,9.93,0,5.66-3,10.25-5.56,10.25a2.54,2.54,0,0,1-2.12-1.42A2.26,2.26,0,0,0,126.48,118Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_113",
    "data-name": "Elipse 113",
    className: "cls-11",
    cx: 102.07,
    cy: 90.24,
    rx: 8.16,
    ry: 4.18,
    transform: "translate(-33.91 98.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_114",
    "data-name": "Elipse 114",
    className: "cls-12",
    cx: 101.93,
    cy: 90.1,
    rx: 8.16,
    ry: 4.18,
    transform: "translate(-33.85 98.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_115",
    "data-name": "Elipse 115",
    className: "cls-11",
    cx: 101.53,
    cy: 89.98,
    rx: 6.93,
    ry: 3.07,
    transform: "translate(-33.89 98.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_116",
    "data-name": "Elipse 116",
    className: "cls-13",
    cx: 101.53,
    cy: 89.84,
    rx: 6.93,
    ry: 3.07,
    transform: "translate(-33.79 98.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1378",
    "data-name": "Trazado 1378",
    className: "cls-15",
    d: "M135,99.74s-1.84.49-1.68,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1388",
    "data-name": "Trazado 1388",
    className: "cls-16",
    d: "M141.45,92.12s3.2.39,3.83,1c0,0-2.8.2-2.92.56,0,0,1.61-1.08,2-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1389",
    "data-name": "Trazado 1389",
    className: "cls-15",
    d: "M134.81,105.78l-.1.1-.33.32c-.14.15-.26.27-.35.38l-.41-.54a1.58,1.58,0,0,1,.47-.28.77.77,0,0,1,.71,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_129",
    "data-name": "Elipse 129",
    className: "cls-17",
    cx: 133.4,
    cy: 106.45,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_130",
    "data-name": "Elipse 130",
    className: "cls-17",
    cx: 133.07,
    cy: 107.25,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_131",
    "data-name": "Elipse 131",
    className: "cls-17",
    cx: 132.06,
    cy: 108.56,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_133",
    "data-name": "Elipse 133",
    className: "cls-17",
    cx: 131.64,
    cy: 109.33,
    r: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1413",
    "data-name": "Trazado 1413",
    className: "cls-11",
    d: "M153.38,119.44l.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1414",
    "data-name": "Trazado 1414",
    className: "cls-18",
    d: "M140.51,122.4a1.73,1.73,0,0,0-.69-.24,4.83,4.83,0,0,1-1.37,0,3.24,3.24,0,0,1,.1,1.2H139S140.51,123,140.51,122.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1415",
    "data-name": "Trazado 1415",
    className: "cls-11",
    d: "M153.27,119.46l.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1419",
    "data-name": "Trazado 1419",
    className: "cls-18",
    d: "M131,112c0,.19,0,.37,0,.53a.87.87,0,0,1-.22.57h0a7.53,7.53,0,0,1-.07-1.16C130.73,112,130.88,112,131,112Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main_btn",
    "data-name": "main btn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illust_offset",
    "data-name": "illust offset"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-nueva-solicitud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_629",
    "data-name": "Grupo 629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_625",
    "data-name": "Grupo 625"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_195",
    "data-name": "Elipse 195",
    className: "cls-20",
    cx: -7.93,
    cy: 25.02,
    r: 8.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_626",
    "data-name": "Grupo 626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1686",
    "data-name": "Trazado 1686",
    className: "cls-21",
    d: "M39.49,87.19c4.8,16.8-4.6,42.3-25.9,35.6-6.1-1.9-11.3-5.8-16.2-9.8-6.3-5.2-13.1-11.2-21.3-12.6-10.9-1.9-22.1,1.2-31.7,6.2-19.3,10-42.8,42.4-67.9,28.5-17.5-9.8-18.2-38.7-2.4-50.1,4.4-3.2,9.4-5.5,13.7-8.9,8.1-6.5,12.2-15.9,13.2-26.2.4-4.9.3-9.8,2.2-14.3a18.79,18.79,0,0,1,14.5-11.3c14.1-1.8,24.4,8.6,34.3,16.8,11.3,9.3,24,14.4,38.5,16.9,17.3,2.9,35.3,4.8,45.4,21A35.25,35.25,0,0,1,39.49,87.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_628",
    "data-name": "Grupo 628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1688",
    "data-name": "Trazado 1688",
    className: "cls-20",
    d: "M14.34,140.38c13.2-5.9,2.6-21.9-9.1-17.9C-8.76,127.28.24,146.58,14.34,140.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_730",
    "data-name": "Grupo 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_718",
    "data-name": "Grupo 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_716",
    "data-name": "Grupo 716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1754",
    "data-name": "Trazado 1754",
    className: "cls-22",
    d: "M32,134.57a39.45,39.45,0,0,0-.8,7.7,8.3,8.3,0,0,0,.6,4.4,1.59,1.59,0,0,0,1.2.9,2.38,2.38,0,0,0,1.1-.6,13.35,13.35,0,0,0,3.3-6.6A45.24,45.24,0,0,0,38,133c0-1.5-.2-4.7-2.6-4.2C33.41,129.17,32.51,132.87,32,134.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_717",
    "data-name": "Grupo 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1755",
    "data-name": "Trazado 1755",
    className: "cls-23",
    d: "M30.42,156.39c-.1,0-.1,0-.1-.1l-3.6-12.6c0-.1,0-.2.1-.2s.2,0,.2.1h0l3.4,12,4.3-22.3c0-.1.1-.1.2-.1s.1.1.1.2l-4.4,22.9c-.1.1-.1.1-.2.1Z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusComprarAuto);
export default __webpack_public_path__ + "static/media/illus-comprar-auto.484ce33c918eb9ee3d41ea4109e05449.svg";
export { ForwardRef as ReactComponent };